export default __webpack_public_path__ + "static/datelabel-dropdown-dont-3-dark-ded4c7493e3c86097210563773c53197.png";